<template>
  <div class="page_part5">
    <div class="page_mulu content">
 
      <h5 class="header page_header page_bg_bl header_title_page">
        <span>Part.3 兴趣倾向</span>
      </h5>
      <h6 class="page_title_2">
        <span>兴趣倾向</span><span class="arrow"></span>
      </h6>
      <div class="header_detail_box">
        <p class="header_detail">
          兴趣是个人对其环境中的人、事、物所产生的喜爱程度，是个人力求认识、掌握某事物，并经常参与该种活动的心理倾向。当个人对某事或物有兴趣时，会对它产生特别的关注和投入，因此兴趣倾向是个体活动的重要动力之一，对活动成功和成就取得有重要影响，可作为决定今后具体发展目标和方向的依据之一。
        </p>
        <p class="header_detail">
          美国心理学家霍兰德对人和职业进行研究，认为职业兴趣是人格的呈现，从事相同职业的人员具有相似的特征，按照兴趣或人格可将个体划分为现实型、研究型、艺术型、社会型、企业型和传统型。职业兴趣没有好坏之分，评估目的在于找到与你更适配的专业和职业，以促成未来生涯的较高满意度和持续稳定发展。
        </p>
      </div>
      <div class="line_box2">
        <p class="career_page">
          <span class="career_page"></span>
          <img
            src="../../../../../public/imgs/cepingreport/page_feng.png"
            alt=""
          />
          兴趣测评结果
        </p>
      </div>
      <div class="bagua">
        <div id="Gossip"></div>
        <div class="result">
          <div class="result_left">
            <p>你的兴趣代码是：<span>{{hobby.threeYard}}</span></p>
          </div>
          <div class="result_right">
            <p>你的兴趣倾向是：<span v-if="hobby.interestTendency">{{hobby.interestTendency[0]}}、{{hobby.interestTendency[1]}}</span></p>
          </div>
        </div>
      </div>
    </div>
  <div class="page_mulu content">
     <div class="line_box2">
        <p class="career_page">
          <span class="career_page"></span>
          <img
            src="../../../../../public/imgs/cepingreport/page_feng.png"
            alt=""
          />
          兴趣类型解读
        </p>
      </div>
        <div class="jieshuo ">
        <div class="jie_list" v-for="(h,index) in hobby.threeYardExplain" :key="index">
          <p class="jie_title">代码类型  <span>{{h.type}}-{{h.name}}</span></p>
          <div class="jie_mian">
            <p>典型特征</p>
            <ul>
              <li v-html="h.feature && h.feature.replace(/\r\n/g,'<br>')"></li>
              <!-- <li>你比较关心社会问题、渴望发挥自己的社会作用。</li>
              <li>你寻求广泛的人际关系，比较看重社会义务和社会道德。</li> -->
            </ul>
            <p>关键词</p>
            <ul>
              <li>
                {{h.keyWords}}
              </li>
            </ul>
          </div>
        </div>
 
      
      </div>
         <div class="jie_bottom">
          <div class="jie_left" v-if="hobby.degree">
            <p>你的兴趣类型之间的一致性程度：<span>{{hobby.degree.degree}}</span></p>
            <p>
              <!-- 说明你感兴趣的职业范围同质性高，兴趣特征显著且稳定，在生涯相关决策中不易出现心理冲突。 -->
              {{ hobby.degree.text}}
            </p>
          </div>
          <div class="jie_right" v-if="hobby.degree">
            <p>你的兴趣类型之间的区分度：<span>{{hobby.distinction.degree}}</span></p>
            <p>
               {{hobby.distinction.text}}
              <!-- 说明你感兴趣的职业范围同质性高，兴趣特征显著且稳定，在生涯相关决策中不易出现心理冲突。 -->
            </p>
          </div>
        </div>
  </div>
      
      <div class="page_mulu content">
            <h6 class="page_title_2">
        <span>职业价值观</span><span class="arrow"></span>
      </h6>
      <div class="header_detail_box">
        <p class="header_detail">
          职业价值观指的是人们在选择并发展自己的职业时所围绕的中心，是一个人在不得不做出职业选择的时候，也不会或不愿放弃的至关重要的东西或价值追求。职业和价值观的匹配度对人们的工作效率、满意度和稳定性有显著影响。
        </p>
        <p class="header_detail">
          美国职业指导专家施恩教授经过多年的职业生涯研究，提出职业锚理论，将职业价值观划分为八种：技能型、管理型、自主型、安全型、创新型、服务型、挑战型和生活型。价值观整合了个体的能力、动机、需要、态度以及价值追求等因素，是你与外界相互作用的产物，可帮助你进行自我认识和对未来目标的探索。
        </p>
      </div>
      <div class="line_box2">
        <p>
          <span class="career_page"></span>
          <img
            src="../../../../../public/imgs/cepingreport/page_feng.png"
            alt=""
          />
          价值观测评结果
        </p>
      </div>
      <div class="linebox" >
        <p class="line_info">你在职业价值观上的测评得分如下图所示：</p>
        <div id="lineTu"></div>
        <div class="echarts_com" >
            <div class="com_left">
                <p>你的主职业锚是：<span>{{profession.main}}</span></p>
            </div>
            <div class="com_right" v-if="profession.deputy">
                <p>你的副职业锚是：<span>{{profession.deputy[0]}}和{{profession.deputy[1]}}</span></p>
            </div>
        </div>
      </div>
      </div>
     
      
      <div class="page_mulu content">
        <div class="line_box2 " style="margin:40px 0 40px 0">
          <p>
            <span class="career_page"></span>
            <img
              src="../../../../../public/imgs/cepingreport/page_feng.png"
              alt=""
            />
            价值观类型解读
          </p>
      </div>
      <div class="page_js"  v-for="(t,index) in threeCategory" :key="index" >
          <div class="page_zyjs" :class="{'bgfont':index === 0,'bgfont2':index === 1,'bgfont3':index === 2}">
               {{t.name}}基本特点
           </div>
           <ul>
               <li>{{t.desc}}</li>
            </ul>
      </div>
      </div>
    </div>

</template>

<script>
export default {
  props:{
    hobby:{
      type:Object
    },
    threeCategory:{
      type:Array
    },
    profession:{
      type:Object
    }
  },
  data() {
    return {};
  },
  created() {
    this.$nextTick(() => {
    //  this.drawLine2();
    });
  },
  mounted() {
   // this.drawLine();
  },
  methods: {
    drawLine() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("Gossip"));
      myChart.setOption({
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          name: {
            formatter: function (value, indicator) {
              let text =
                indicator.value < 10
                  ? "{a|" + value + "}"
                  : "{b|" + value + "}";
              return text;
            },
            rich: {
              a: {
                color: "#2F2F2F",
                fontSize: 14,
              },
              b: {
                color: "#1CA4B6",
                fontSize: 18,
              },
            },
            textStyle: {
              color: "#4D4D4D",
              fontSize: 14,
              fontWeight: "bold",
              padding: [3, 5],
            },
          },

          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          radius: "70%",
          center: ["50%", "50%"],
          // indicator: [
          //   { name: "R-实际型", max: 20, value: 5 },
          //   { name: "I-研究型", max: 20, value: 8 },
          //   { name: "A-艺术型", max: 20, value: 15 },
          //   { name: "S-社会型", max: 20, value: 20 },
          //   { name: "E-企业型", max: 20, value: 6 },
          //   { name: "C-传统型", max: 20, value: 10 },
          // ],
        },
        series: [
          {
            name: "测评结果",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: [5, 8, 15, 20, 6, 10],
                name: "测评结果",
                label: {
                  show: true,
                  formatter: function (params) {
                    if (params.value <= 10) {
                      return "{a|" + params.value + "}";
                    } else {
                      return "{b|" + params.value + "}";
                    }
                  },
                  rich: {
                    a: {
                      color: "#2F2F2F",
                      fontSize: 14,
                    },
                    b: {
                      color: "#1CA4B6",
                      fontSize: 18,
                    },
                  },
                },
              },
            ],
            areaStyle: {
              color: "rgba(184,232,255,0.8)",
            },
            lineStyle: {
              color: "#1CA4B6",
              width: 2,
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              color: "#2F2F2F",

              // fontWeight:'bold'
            },
            symbol: "circle",
            symbolSize: 4,
            showAllSymbol: false,

            itemStyle: {
              color: "white",
              borderColor: "#1CA4B6",
              borderWidth: 2,
            },
          },
        ],
      });
    },
    drawLine2() {
      const colors = ['#00B14B','#06A4B7', '#06A4B7', '#FF0000', '#90D246','#00B14B','#00B14B','#90D246'];
      var bkData = [100, 100, 100, 100, 100, 100,100,100];
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("lineTu"));
      myChart.setOption({
        backgroundColor: "",
        color: ["#3398DB"],
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "rgb(7,55,133)",
          borderColor: "#0daee9",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true, // 坐标轴两边留白
            gridIndex: 0,
            data: ["技术型", "管理型", "自主型", "安全型", "创新型", "服务型","挑战型","生活型"],
            axisLabel: {
              textStyle: {
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,.8)",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name:"分值",  
            type: "value",
            nameTextStyle: {
              color: "rgb(170,170,170)",
            },
            gridIndex: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                // color: 'rgba(255,255,255,0)'
              },
            },
            axisLabel: {
              color: "rgba(0,0,0,.8)",
              fontSize: 12,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
          {
            type: "value",
            show: false,
            gridIndex: 0,
            // min: min,
            // max: 6,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#95a2aa",
              fontSize: 14,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
        ],
        series: [
          {
            // name: "高发事件统计",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: function(params){
                    return colors[params.dataIndex]; 
                },
              },
            },
            label: {
              show: true,
              position: "top",
            },
            data: [123,152,168,189,175,158,163,174],
            zlevel: 11,
          },
          {
            name: "背景",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: bkData,
            itemStyle: {
              normal: {
                color: "rgba(0,162,255,0.1)",
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            tooltip: {
              show: false,
            },
            zlevel: 9,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
@import './report.css';
#lineTu {
  width: 100%;
  height: 400px;
}
#Gossip {
  width: 100%;
  height: 600px;
}
.jie_list {
  width: 100%;
  /* height: 252px; */
  border: 1px dashed #e6e6e6;
  border-radius: 6px 6px 0px 0px;
  background: #f6f6f6;
  padding: 0 10px 10px;
  box-sizing: border-box;
  margin-top: 25px;
}
.jie_list p.jie_title {
  font-size: 14px;
  font-weight: 400;
  color: #2f2f2f;
  height: 44px;
  line-height: 44px;
  border-bottom: 1px dashed #e6e6e6;
}
.jie_list .jie_title span {
  font-size: 16px;
  color: #1ca4b6;
  font-weight: 600;
}
.jie_mian p {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  margin-top: 15px;
}
.jie_mian ul li {
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  color: #9e9e9e;
}

.result {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.result_left,
.result_right {
  width: 315px;
  height: 40px;
  background: #f6f6f6;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
}
.result_left p span {
  font-size: 20px;
  color: #1ca4b6;
  vertical-align: top;
}
.result_right p span {
  font-size: 20px;
  color: #f6a724;
  vertical-align: top;
}


 h5.page_bg_o {
  background-color: #feae3b;
}

 h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin: 30px 0 15px 0;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 20px 0 10px 0;
}
.page_part2 .page_title_2 .arrow {
}
 h5.page_bg_bl {
  background-color: #1ca4b6;
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
 .page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin: 40px 0 20px 0;
}

.jie_bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.jie_left {
  width: 334px;
  height: 163px;
  background: url("../../../../../public/imgs/cepingreport/page_3_33.png")
    no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_right {
  width: 334px;
  height: 163px;
  background: url("../../../../../public/imgs/cepingreport/page_3_34.png")
    no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_left p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;
}
.jie_left p:first-child span {
  font-size: 16px;
  color: #ffc002;
  font-weight: 600;
     margin-left: 10px;
}
.jie_left p:last-child {
  margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 1.5;
}
.jie_right p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;

}
.jie_right p:first-child span {
  font-size: 16px;
  color: #28dfa0;
  font-weight: 600;
     margin-left: 10px;
}
.jie_right p:last-child {
  margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 1.5;
}
.bgfont{
  background: #f6a724;
}
.bgfont2{
   background: #1CA4B6;
}
.bgfont3{
   background: #1CA4B6;
}

.linebox .line_info{
    font-size: 14px;
    font-weight: 400;
    color: #B0B0B0;
    margin: 15px 0; 
}
.echarts_com{
    display: flex;
    justify-content: space-between;
}
.com_left,.com_right{
    width: 311px;
    height: 40px;
    background: #F6F6F6;
    border-radius: 6px;
    line-height: 40px;
    text-align: center;
}
.com_left p,.com_right p{
    font-size: 14px;
    color: #2F2F2F;
}

.com_left p span{
  color: #FEAE3B;
    font-size: 16px;
    font-weight: 600;
}
.com_right p span{
    color: #1CA4B6;
    font-size: 16px;
    font-weight: 600;
}
.page_js{
    margin-bottom: 60px;
    height: auto;
    background: #f5f5f5;
    border-radius: 6px;
    padding: 30px 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
}
.page_js .page_bg_o{
    background: #FEAE3B;
}
.page_js .page_bg_bl{
    background: #00B3F0;
}
.page_js .page_bg_g{
    background: #AACF00;
}
.page_zyjs{
    width: auto;
    padding: 0 15px;
    height: 30px;
    /* background: #3AB3C1; */
    border-radius: 6px;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    top: -15px;
}
.page_js ul li{
    text-indent: 2em;
    line-height: 2;
    font-size: 14px;
    color: #969696;
}
</style>